import type { IconProps } from '../types/IconProps.ts';
export const MapPin: IconProps = {
    name: 'MapPin',
    children: [
        `<path d="m12.04 21.93 5.79-9.64a6.8 6.8 0 1 0-11.66 0l5.79 9.64q.04.05.08 0" />`,
        `<circle cx="12" cy="9" r="2" />`,
    ]
};